import { Moment } from 'moment';

export type PriorityType = 1 | 2 | 3;

export enum TaskType {
	ADMINISTRATIVE = 'ADMINISTRATIVE',
	ENGINEERING = 'ENGINEERING'
}

export type Task = {
	id?: string;
	title: string;
	due_date: Moment | undefined;
	is_completed: boolean;
	responsible_user_id: string | undefined;
	default?: boolean;
	type?: TaskType;
};

export type CreateActionPlanPayload = any;

export interface FormDataValues {
	title: string;
	responsible: string;
	due_date: Moment;
	priority: PriorityType;
	investment_range: number;
	investment_value: number;
	description: string;
	task_list: Task[];
	attachments: any[];
	responsible_user_id: string;
}
